import { useMemo } from 'react';

import useWindowSize from './use-window-size';

import { WindowWidth } from 'src/constants';

export default function useIsLaptop() {
  const windowSize = useWindowSize();

  return useMemo(() => windowSize.width >= WindowWidth.LAPTOP, [windowSize.width]);
}
